export function linkToEditPatient(id = ":patientId") {
  return `/edit/patient/${id}`;
}
